import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ steps, currentStep }) => {
  return (
    <div className="py-5 px-6 bg-bg-tertiary border-b border-border-primary flex-shrink-0 md:py-4 md:px-4">
      <div className="flex justify-between mb-4 relative md:mb-3">
        {steps.map((step, index) => (
          <div 
            key={step.id}
            className="flex flex-col items-center gap-2 flex-1 relative"
          >
            <div className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold border-2 transition-all duration-300 shadow-sm z-[2] ${index === currentStep ? 'bg-primary-600 text-white border-primary-600 ring-4 ring-primary-500/10 scale-105' : index < currentStep ? 'bg-primary-600 text-white border-primary-600' : 'bg-bg-secondary text-text-tertiary border-border-primary'} md:w-8 md:h-8 md:text-xs`}>
              {index < currentStep ? (
                <span className="text-sm">✓</span>
              ) : (
                <span className="text-[13px]">{index + 1}</span>
              )}
            </div>
            <span className={`text-xs font-medium text-center transition-all duration-fast whitespace-nowrap ${index === currentStep ? 'text-text-primary font-semibold' : index < currentStep ? 'text-text-secondary' : 'text-text-tertiary'} md:text-[10px] sm:hidden`}>{step.title}</span>
          </div>
        ))}
      </div>
      <div className="h-[3px] bg-border-primary rounded-full overflow-hidden relative">
        <div 
          className="h-full bg-gradient-to-r from-primary-600 to-primary-500 rounded-full transition-[width] duration-[400ms] ease-smooth relative shadow-[0_0_8px_rgba(99,102,241,0.3)]" 
          style={{ width: `${(currentStep / (steps.length - 1)) * 100}%` }}
        />
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  })).isRequired,
  currentStep: PropTypes.number.isRequired,
};

export default ProgressBar;
